import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VertesiaErrorBoundary } from "./VertesiaErrorBoundary";
export function RowErrorBoundary({ children }) {
    return (_jsx(VertesiaErrorBoundary, { fallback: RowErrorFallback, children: children }));
}
function RowErrorFallback({ error }) {
    return (_jsx("tr", { children: _jsxs("td", { colSpan: 100, children: [_jsx("span", { className: "text-xs", children: " Cannot display row" }), _jsx("br", {}), _jsx("span", { className: "bg-gray-400", children: error?.message })] }) }));
}
//# sourceMappingURL=RowErrorBoundary.js.map